var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "venue-app-home" } },
    [
      _c("div", { staticClass: "home-wrapper" }, [
        _vm.loadingEvents || (!_vm.loadingEvents && _vm.eventsTotal > 0)
          ? _c("div", { staticClass: "venue-events" }, [
              _c("div", { staticClass: "section-header" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right-col" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "VenueAppEvents",
                            params: { venueId: _vm.venue.slug },
                          },
                        },
                      },
                      [_vm._v("\n            View all\n          ")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.loadingEvents
                ? _c(
                    "div",
                    { staticClass: "loading-wrapper" },
                    [_c("loading")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loadingEvents
                ? _c(
                    "div",
                    { staticClass: "events" },
                    [
                      _c("event-carousel", {
                        attrs: { "venue-id": _vm.venue.id },
                        on: { eventClicked: _vm.onEventClicked },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "venue-book" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "inventory-list" },
            [_c("inventory-list-with-date-picker")],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left-col" }, [
      _c("h2", [
        _c("span", { staticClass: "visible-lg visible-md" }, [
          _vm._v("\n              Upcoming Events\n            "),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "visible-sm visible-xs" }, [
          _vm._v("\n              Events\n            "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("div", { staticClass: "left-col" }, [_c("h2", [_vm._v("Book")])]),
      _vm._v(" "),
      _c("div", { staticClass: "right-col" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/pages/Venue/VenueAppHome/template.html?vue&type=template&id=427190d8&
// module id = 1090
// module chunks = 0